// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoSessions_wrapper__1Hbb5","image":"NoSessions_image__2E3or","button":"NoSessions_button__3FrqG"};